/* ============
 * Vuex Getters
 * ============
 *
 * All the getters that can be used
 * inside the store
 */

export const account = (state) => state.account;



// WEBPACK FOOTER //
// ./src/app/store/getters.js